// extracted by mini-css-extract-plugin
export default {"container":"AssessmentSheetSectionTitle_container__5t3lZ"};